module.exports = __webpack_public_path__ + "img/w12.6103a522.svg";